import React from "react";
import emailIcon from "../../Assets/Images/emailIcon.png";
import callIcon from "../../Assets/Images/call-icon.png";
import locationIcon from "../../Assets/Images/locationIcon.png";

const ContactInfo = () => {
  return (
    <section
      className="container-fluid  pb-5 d-flex justify-content-center"
      style={{ backgroundColor: "#fff", marginTop: "0" }}
    >
      <div className="sectionContainer  " style={{ maxWidth: "full" }}>
        {/* Title */}

        {/* Contact Info + Map */}
        <div className="row g-0 align-items-stretch position-relative">
          {/* Left Side */}
          <div
            className=" col-lg-6 position-relative text-start"
            style={{ zIndex: 0, marginRight: "-60px" }}
          >
            <div
              className="p-4 h-100 rounded-3 shadow-sm text-start"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              {/* Email */}
              <div className="mb-4 pb-2 text-start">
                <h2
                  className="col-12 text-start"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    fontSize: "2.5rem",
                    paddingBottom: "1.5rem",
                  }}
                >
                  Contact Information
                </h2>
                <h5 className="fw-semibold sub-heading mb-4">E-Mail Us</h5>
                <p className="mb-1">
                  <a
                    href="mailto:info@quadtheoryltd.com"
                    className="text-decoration-none database-text text-muted"
                  >
                    <img className="pe-2" src={emailIcon} alt="" />
                    info@quadtheoryltd.com
                  </a>
                </p>
              </div>

              {/* Phone */}
              <div className="mb-4 pb-2 text-start">
                <h5 className="fw-semibold sub-heading mb-4">Call Us</h5>
                <p
                  className="mb-1 border-bottom"
                  style={{ width: "90%", padding: "4px" }}
                >
                  <a
                    href="tel:+8801776013574"
                    className="text-decoration-none database-text text-muted"
                  >
                    <img className="pe-2" src={callIcon} alt="" />
                    +8801776013574
                  </a>
                </p>
              </div>

              {/* Offices */}
              <div className="pb-2 text-start">
                <h5 className="fw-semibold sub-heading mb-4">Our Offices</h5>
                <p className="mb-3 database-text text-muted">
                  <img className="pe-2 " src={locationIcon} alt="" />
                  Brayford Square, London
                </p>
                <p className="mb-0 database-text text-muted">
                  <img className="pe-2" src={locationIcon} alt="" />
                  Banasree-B, Road-1, House-21, Dhaka-1219
                </p>
              </div>
            </div>
          </div>

          {/* Right Side (Map) */}
          <div
            className="col-lg-6 position-relative"
            style={{
              zIndex: 1,
            }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3648.384284760387!2d90.4255!3d23.7694!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c71aaeb538a7%3A0x94846b3432055426!2sQuad%20Theory%20Ltd.!5e0!3m2!1sen!2sbd!4v1687866475424!5m2!1sen!2sbd"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              style={{
                border: 0,
                width: "100%",
                height: "100%",
                minHeight: "350px",
                borderRadius: "10px",
              }}
              title="Google Map"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
